import React from 'react'
import "./assets/style/style.scss"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import RoutesPage from './routes'
const App = () => {
  return (
    <div >
      <RoutesPage />
    </div>
  )
}

export default App